import React from "react";

const ResetIcon = () => {
  return (
    <>
      <svg width="20" height="20" viewBox="0 0 20 20">
        <path
          id="Path_2543"
          data-name="Path 2543"
          d="M22,12A10,10,0,1,1,12,2V4a8,8,0,1,0,5.135,1.865L15,8V2h6L18.553,4.447A9.98,9.98,0,0,1,22,12"
          transform="translate(-2 -2)"
        />
      </svg>
    </>
  );
};

export default ResetIcon;
